export const PatientEngagementDescription = () => {
  return (
    <>
      <p>
        The Patient Engagement dashboard offers a comprehensive view of engagement activities for a single study, from
        high-level study metrics down to individual actions. This dashboard is designed to help teams visualize and
        understand the full scope of patient engagement efforts, monitor progress, and uncover opportunities for
        improvement.
      </p>
      <strong>Filter Notes:</strong>
      <ul>
        <li>
          Date filters apply only to the Weekly Engagement and Detailed Engagement Activities tables. If no date filters
          are selected, these tables will display all-time data. All other sections always show all-time counts.
        </li>
        <li>
          The Team Members filter applies only to the Weekly Engagement table. By default, all team members are
          selected.
        </li>
      </ul>
    </>
  );
};
